export enum RuleAttributeType {
    RespondedToQuestion = 'respondedToQuestion',
    CompletedConvo = 'completedConvo',
    StartedConvo = 'startedConvo',
    UserLocation = 'userLocation',
    JoinedChannel = 'joinedChannel',
}
